import { api } from "./api";

export const fileTestApi = api.injectEndpoints({
  endpoints: (builder) => ({

    /* =========================
       1️⃣ FAYLDAN TEST YARATISH
    ========================== */
    generateFileTest: builder.mutation({
      query: ({
        file,
        questionCount,
        optionCount,
        language,
        difficulty,
      }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("questionCount", questionCount);
        formData.append("optionCount", optionCount);
        formData.append("language", language);
        formData.append("difficulty", difficulty);

        return {
          url: "/file-test/upload",
          method: "POST",
          body: formData,
        };
      },
    }),

    /* =========================
       2️⃣ MENING TESTLARIM (LIST)
    ========================== */
    getMyTests: builder.query({
      query: ({ limit = 50, offset = 0 }) => ({
        url: `/my-tests?limit=${limit}&offset=${offset}`,
        method: "GET",
      }),

      // delete bo‘lganda list avtomatik yangilansin
      providesTags: ["MyFileTests"],
    }),

    /* =========================
       3️⃣ TESTNI O‘CHIRISH
    ========================== */
    deleteMyTest: builder.mutation({
      query: (id) => ({
        url: `/my-tests/${id}`,
        method: "DELETE",
      }),

      // o‘chirilgach listni refresh qiladi
      invalidatesTags: ["MyFileTests"],
    }),

  }),
});

/* =========================
   HOOKLAR EXPORTI
========================== */
export const {
  useGenerateFileTestMutation,
  useGetMyTestsQuery,
  useDeleteMyTestMutation,
} = fileTestApi;
